import axios from 'axios'
import {getToken, removeToken} from './auth'
import router from '@/router/index'
import { addPendingRequest, removePendingRequest } from './http_stop';
import {Message, MessageBox} from 'element-ui'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api的base_url
    timeout: 40000                  //超时时间
})

service.defaults.headers.post["Content-Type"] = 'text/plain'

// 发送请求
service.interceptors.request.use(config => {
      /// 检查是否存在重复请求，若存在则取消已发的请求
      removePendingRequest(config);
      // 把当前请求信息添加到pendingRequest对象中
      addPendingRequest(config);
    if (getToken()) {
        config.headers.token = getToken()
    }
    return config
}, error => {
    console.log(JSON.stringify(error)) // 打印错误信息
    Promise.reject(error)
})

// 接收响应
service.interceptors.response.use(response => {
  removePendingRequest(response.config);
    if (response && response.data) {
        switch (response.data.code) {
            case 401://未授权
                removeToken()
                defaultUnLoginRedirect()
                break;
            case 500://内部错误
                if (response.data
                    && response.data.detail) {
                    console.log(response.data.detail)
                }
                break;
        }
    }
    return response
}, error => {
    // debugger
    if (error && error.response) {
        switch (error.response.status) {
            case 401://未授权
                removeToken()
                defaultUnLoginRedirect()
                break;
            case 500://内部错误
                if (error.response.data
                    && error.response.data.detail) {
                    console.log(error.response.data.detail)
                }

                return Promise.resolve(error.response)
        }
    }
    return Promise.reject(error.response)
})

/*默认未登陆跳转*/
function defaultUnLoginRedirect() {
    if (router.currentRoute.meta
        && router.currentRoute.meta.isBackend) {
        router.replace({
            path: '/admin/login', query: {redirect: router.currentRoute.fullPath}
        })
    } else {
        router.replace({path: '/login', query: {redirect: router.currentRoute.fullPath}})
    }
}

/*默认登陆成功跳转*/
function defaultLoginRedirect() {
    if (router.currentRoute.meta
        && router.currentRoute.meta.isAdmin) {
        router.replace({
            path: '/admin//customer'
        })
    } else {
        router.replace({path: '/epmc'})
    }
}

export default service



// WEBPACK FOOTER //
// ./src/common/js/http.js